// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React,{ createContext, useState } from "react";

export const CidadeIdContext = createContext()

export const CidadeIdContextProvider = ({children}) => {
    const [cidadeIdContext, setCidadeIdContext] = useState('')

    return (
        <CidadeIdContext.Provider value={{cidadeIdContext, setCidadeIdContext}}>
            { children }
        </CidadeIdContext.Provider>
    )
}